import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

/**
 * Opens the standalone Contract Repository app (Physician mode) in a new tab.
 * If the browser blocks the popup, falls back to a same-tab redirect.
 */
@Component({
  selector: 'app-contract-repository-redirect',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
})
export class ContractRepositoryRedirectComponent implements OnInit {
  private readonly router = inject(Router);

  ngOnInit(): void {
    const target = environment.uiUrl.contractRepositoryURL;
    const opened = window.open(target, '_blank');
    if (opened) {
      this.router.navigateByUrl('/contracts');
    } else {
      window.location.replace(target);
    }
  }
}
